import { images } from "../constants";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to DriveOn",
    heading: "Premium Car Rentals for Every Journey",
    price: "$38",
    buttonText: "Rent a Car",
    buttonLink: "Car-Booking",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to DriveOn",
    heading: "Luxury & Economy Cars at the Best Rates",
    price: "$38",
    buttonText: "Rent a Car",
    buttonLink: "Car-Booking",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to DriveOn",
    heading: "Flexible Rental Plans for Your Convenience",
    price: "$38",
    buttonText: "Rent a Car",
    buttonLink: "Car-Booking",
  },
];

export default home;